// extracted by mini-css-extract-plugin
export default {"page":"Page_page__Y+LO6","page__inner":"Page_page__inner__INftZ","page--has_menu":"Page_page--has_menu__YM5y6","spin":"Page_spin__0Qa08"};